<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Chuyên ngành</h2>
        <el-button @click="createModel" size="small" type="info" class="btn-create">Thêm mới</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="table.pagination.per_page"
            :pager-count="table.pagination.count"
            :current-page="table.pagination.current_page"
            :total="table.pagination.total"
            @current-change="changeCurrentPage">
          </el-pagination>
          <div style="padding-left: 5px">
            Hiển thị tới Chuyên ngành <strong>{{ table.meta_pagination }}</strong> / Tổng số: <strong>{{ table.pagination.total }}</strong> Chuyên ngành
          </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table
          v-loading="loading"
          border
          :data="table.database"
          style="width: 100%">
          <el-table-column
            label="#"
            type="index"
            width="40">
          </el-table-column>
          <el-table-column
            prop="name"
            label="Chuyên ngành">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
<!--           <el-table-column
            prop="code"
            label="Mã">
            <template slot-scope="scope">
              <span>{{ scope.row.code }}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="priority"
            width="80"
            align="center"
            label="Ưu tiên">
          </el-table-column>
          <el-table-column
            width="120"
            label="Trạng thái">
            <template slot-scope="scope">
              <div v-if="scope.row.status" class="item_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
              <div v-else class="item_not_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Kích hoạt"
            width="80"
            align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                @change="changeStatus(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            label="Hành động"
            width="180"
            header-align="center">
            <template slot-scope="scope">
              <div class="module-action">
                <el-tooltip effect="dark" content="Xem" placement="top">
                  <span @click="showModel(scope.row)">
                    <i class="fas fa-search icon-search"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Sửa" placement="top">
                  <span @click="updateModel(scope.row)">
                    <i class="far fa-edit icon-update"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Xóa" placement="top">
                  <span @click="confirmDeleteModel(scope.row)">
                    <i class="far fa-trash-alt icon-delete"></i>
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'Promotions',
  metaInfo () {
    return {
      title: 'Chuyên ngành'
    }
  },
  data () {
    return {
      loading: false,
      searching: false,
      filter: {
        q: '',
        status: '',
        daterange: '',
        level_id: '',
        page: 1,
        limit: 15,
        sorted: '',
        include: 'user'
      },
      sort: [
        {
          groupName: 'Không sắp xếp',
          groupFiled: [
            { label: '', text: 'Không sắp xếp' }
          ]
        },
        {
          groupName: 'Tên',
          groupFiled: [
            { label: 'name:-1', text: 'Tăng dần' },
            { label: 'name:1', text: 'Giảm dần' }
          ]
        }
      ],
      lists: {
        listStatus: [
          {key: 1, value: 'Kích hoạt'},
          {key: 0, value: 'Chưa kích hoạt'}
        ],
        listCategoryBlogs: [
          {key: 1, value: 'Menu chính'},
          {key: 2, value: 'Footer cột Giới thiệu'},
          {key: 3, value: 'Footer cột Cộng tác viên Affiliate'},
          {key: 4, value: 'Footer cột Chính sách'}
        ],
        listLevel: []
      },
      table: {
        database: [],
        meta_pagination: 0,
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        },
        timer: {}
      }
    }
  },
  mounted () {
    // this.configBreadcrumb()
    this.filter.level_id = this.$route.params.level_id
    this.filter.facult_id = this.$route.params.facult_id
    this.fetchDatabaseModel()
    // this.fetchListCategoryCourse()
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'specializeds-index', text: 'Chuyên ngành' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút tạo Model
    createModel () {
      this.$router.push({name: 'specializeds-create', params: {level_id: this.$route.params.level_id, facult_id: this.$route.params.facult_id}})
      // this.$router.push({name: 'specializeds-create'})
    },
    // Fetch dữ liệu
    fetchDatabaseModel () {
      this.loading = true
      axios.get('specializeds', {params: this.filter}).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.specializeds(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về danh mục tin tức
    fetchListCategoryCourse () {
      axios.get('levels', {params: {'status': 1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listLevel = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination () {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
    // Xem chi tiết
    showModel (model) {
      // let routeData = this.$router.resolve({name: 'specializeds-show', params: {id: model.id}})
      // window.open(routeData.href, '_blank')
      this.$router.push({name: 'specializeds-show', params: {specialized_id: model.id, level_id: this.$route.params.level_id}})
    },
    updateModel (model) {
      // let routeData = this.$router.resolve({name: 'specializeds-update', params: {id: model.id}})
      // window.open(routeData.href, '_blank')
      this.$router.push({name: 'specializeds-update', params: {specialized_id: model.id, level_id: this.$route.params.level_id}})
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeStatus (model) {
      let dataUpdate = {
        'status': model.status
      }
      axios.post('specializeds/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // confirmDeleteModel
    confirmDeleteModel (model) {
      this.$confirm('Xác nhận xóa : ' + model.name, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel (model) {
      axios.delete('specializeds/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal (model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    },
    // Thay đổi Current Page
    changeCurrentPage (currentPage) {
      this.filter.page = currentPage
      this.fetchDatabaseModel()
    }
  },
  watch: {
    'filter.status': function () {
      this.fetchDatabaseModel()
    },
    'filter.level_id': function () {
      this.fetchDatabaseModel()
    },
    'filter.q': function () {
      this.searching = true
      clearTimeout(this.timer)
      let _this = this
      this.timer = setTimeout(function () {
        _this.searching = false
        _this.fetchDatabaseModel()
      }, 800)
    },
    'filter.sort': function () {
      this.fetchDatabaseModel()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-filter-search {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #efefef;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.model-filter-radio {
  margin-bottom: 10px;
}
.model-filter-radio span {
  margin-right: 20px;
  width: 135px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/specializeds/Index.vue